import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {EvidVidsService} from '@catmodules/models/evid-vids/services/evid-vids.service';

const publicComponents = [
];

const imports = [
  CommonModule,
];
const declarations = [
  ...publicComponents,
];

const exportings = [...publicComponents];

const providers = [EvidVidsService];
const entryComponents = [...publicComponents];

@NgModule({
  declarations,
  entryComponents,
  exports: exportings,
  imports,
  providers,
})
export class EvidVidsModule {
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/evid-vids/evid-vids.module.ts